import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5700%3A259
 *
 * @param {SvgIconProps} props - svg props
 */
export const NotificationCounterIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <ellipse cx='12' cy='12' rx='11' ry='11' fill={color}/>
            <path d='M13.8098 13.129H15.2948V14.13H13.6888L13.4578 16H12.4568L12.6878 14.13H10.8288L10.5978 16H9.59684L9.82784 14.13H8.34284V13.129H9.94884L10.2018 11.171H8.71684V10.17H10.3228L10.5538 8.3H11.5548L11.3238 10.17H13.1718L13.4028 8.3H14.4038L14.1728 10.17H15.6468L15.6578 11.171H14.0518L13.8098 13.129ZM12.8088 13.129L13.0508 11.171H11.2028L10.9498 13.129H12.8088Z' fill='white'/>
        </SvgIcon>
    )
}

export default NotificationCounterIcon
